import ScrollToTopButton from "./ScrollToTopButton";

export default ScrollToTopButton;
